import { useEffect, useRef, useState, type FC } from 'react';
import { Button, Stack } from '@carbon/react';
import { ArrowRight } from '@carbon/icons-react';

import type { DadosDoDiagnostico } from '../../../../logica/desenvolvimento/useDiagnostico';
import { CorpoDoDiagnostico } from './Diagnostico';
import styles from './Entrega.module.scss';

// A ENTREGA DO DIAGNÓSTICO, nos dois fluxos de tela cheia que a fazem (criar o perfil e desbloquear
// o perfil): o cabeçalho da entrega e o relatório, com a chamada do planejamento sempre à mão. As
// quatro dimensões vêm em sequência, e não em abas: quem acaba de receber o diagnóstico lê todas.
// O relatório é longo: passado o cabeçalho, e enquanto a chamada não está na tela, o botão dela fica
// fixo no pé (no refazer não há chamada, e nada fica fixo).

export const Entrega: FC<{
  cabecalho: { titulo: string; apoio: string };
  dados: DadosDoDiagnostico;
  relatorio: NonNullable<DadosDoDiagnostico['relatorio']>;
}> = ({ cabecalho, dados, relatorio }) => {
  const cabeca = useRef<HTMLDivElement>(null);
  const [fixo, setFixo] = useState(false);
  useEffect(() => {
    const topo = cabeca.current;
    const chamada = document.querySelector('[data-chamada-do-planejamento]');
    if (!dados.planejamento || !topo || typeof IntersectionObserver === 'undefined') return undefined;
    let passou = false;
    let chamadaNaTela = false;
    const atualizar = () => setFixo(passou && !chamadaNaTela);
    const o1 = new IntersectionObserver(([x]) => { passou = !x.isIntersecting && x.boundingClientRect.top < 0; atualizar(); });
    o1.observe(topo);
    const o2 = chamada ? new IntersectionObserver(([x]) => { chamadaNaTela = x.isIntersecting; atualizar(); }, { threshold: 0.15 }) : undefined;
    if (chamada && o2) o2.observe(chamada);
    return () => { o1.disconnect(); o2?.disconnect(); };
  }, [dados.planejamento]);
  return (
    <Stack gap={7} className={dados.planejamento ? styles.comBarra : undefined}>
      <div className={styles.cabeca} ref={cabeca}>
        <h2 className={styles.titulo} tabIndex={-1} data-foco-do-passo=''>{cabecalho.titulo}</h2>
        <p className={styles.texto}>{cabecalho.apoio}</p>
      </div>
      <CorpoDoDiagnostico d={dados} relatorio={relatorio} emSequencia />
      {dados.planejamento && fixo && (
        <div className={styles.barraFixa}>
          <Button kind='primary' size='lg' renderIcon={ArrowRight} onClick={dados.planejamento.abrir}>{dados.planejamento.botao}</Button>
        </div>
      )}
    </Stack>
  );
};
